
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { queryClinic,queryClinicByAccountid } from '@/api/xiqueClinc'
import config from '@/config/index'
import { getConfig, addFile } from '@/api/wx.js'
export default {
components: { XTextarea },
data () {
return {
baseUrl: config.baseUrl,
querycontent: '',
photoObj: {
imgcount: 9,
imglist: [],
fileUrlArr: []
}
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
clinictype () {
if (this.$route.name === 'xiqueClincGeneral') {
return 1
} else if (this.$route.name === 'xiqueClincReport') {
return 2
}else if(this.$route.name === 'xiqueClincZhuanjia'){
return 3
}
return ''
},
clinicaccountid(){
if(this.$route.name === 'xiqueClincZhuanjia'){
return this.$route.params.id
}else {
return ''
}
}
},
mounted () {
this.wxconfig()
},
methods: {
submit () {
if (this.querycontent === '') {
this.$vux.toast.text('请先填写咨询描述')
return false
}
let arr = this.photoObj.imglist.map(item => item.id)
let queryimgs = arr.join(';')
if(this.$route.name === 'xiqueClincZhuanjia'){
queryClinicByAccountid({
accountid: this.accountid,
clinicid: 1025,
clinicaccountid:this.clinicaccountid,
querycontent: this.querycontent,
queryimgs: queryimgs,
clinictype: this.clinictype
}).then(res => {
if (res.status === 'suc') {
this.$vux.toast.text('提交成功')
setTimeout(() => {
this.$router.push({ name: 'xiqueClincConsult' })
}, 1200)
}
})
}else {
queryClinic({
accountid: this.accountid,
clinicid: 1025,
querycontent: this.querycontent,
queryimgs: queryimgs,
clinictype: this.clinictype
}).then(res => {
if (res.status === 'suc') {
this.$vux.toast.text('提交成功')
setTimeout(() => {
this.$router.push({ name: 'xiqueClincConsult' })
}, 1200)
}
})
}
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
console.log(href)
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, imgcount) {
let count = imgcount - imglist.length

var _this = this
wx.chooseImage({
count: count, // 默认9
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
}
}
}
